import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";
import { EntityType, Module } from "@/constants";

interface GetDeletedFormsParams {
  locationId: string;
}

interface RestoreSurveyParams {
  id: string;
  name: string;
}

interface GetDeletedSurveyParams {
  locationId: string;
}

interface RestoreFormsParams {
  id: string;
  name: string;
}

interface GetAllFormsForThemesParams {
  locationId: string;
  limit: number;
}

interface GetAllSurveysForThemesParams {
  locationId: string;
  limit: number;
}

interface GetThemesParams {
  locationId: string;
}

const FormsAndSurveyServices = {
  getDeletedFormsByLocation: (params: GetDeletedFormsParams) =>
    requests(SERVICE_NAME.FORMS_API).get("deleted-forms", { params }),

  restoreFormsByIdAndName: (params: { forms: RestoreFormsParams[] }) =>
    requests(SERVICE_NAME.FORMS_API).post("restore-forms", params),

  getDeletedSurveyByLocation: (params: GetDeletedSurveyParams) =>
    requests(SERVICE_NAME.SURVEYS_API).get("deleted-surveys", { params }),

  restoreSurveyByIdAndName: (params: { surveys: RestoreSurveyParams[] }) =>
    requests(SERVICE_NAME.SURVEYS_API).post("restore-surveys", params),

  getAllFormsForThemes: (params: GetAllFormsForThemesParams) =>
    requests(SERVICE_NAME.FORMS_API).get("", { params }),

  createThemes: (body: any) =>
    requests(SERVICE_NAME.FORMS_API).post("theme", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  getThemeListForms: (params: GetThemesParams) =>
    requests(SERVICE_NAME.FORMS_API)
      .log({
        module: Module.FORMS_SURVEYS,
        entityType: EntityType.LOCATION,
        entityId: params.locationId,
      })
      .get("themes", { params }),

  getPrebuiltFormsList: (params: GetThemesParams) =>
    requests(SERVICE_NAME.FORMS_API)
      .log({
        module: Module.FORMS_SURVEYS,
        entityType: EntityType.LOCATION,
        entityId: params.locationId,
      })
      .get("themes", {
        params: { ...params, isCategoryThemes: true },
      }),

  deleteThemeInForms: (themeId: string) =>
    requests(SERVICE_NAME.FORMS_API).delete(`themes/${themeId}`),

  /**
   * Update theme metadata for forms or surveys
   */
  updateThemes: (
    kind: "forms" | "surveys",
    id: string,
    data: { category: string; priority: number }
  ) =>
    (kind === "forms"
      ? requests(SERVICE_NAME.FORMS_API)
      : requests(SERVICE_NAME.SURVEYS_API)
    )
      .log({
        module: Module.FORMS_SURVEYS,
        entityType: EntityType.LOCATION,
        entityId: id,
        documentId: id,
      })
      .put(`themes/${id}`, data),

  getAllSurveysForThemes: (params: GetAllSurveysForThemesParams) =>
    requests(SERVICE_NAME.SURVEYS_API).get("", { params }),

  createSurveys: (body: any) =>
    requests(SERVICE_NAME.SURVEYS_API).post("theme", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  getThemeListSurveys: (params: GetThemesParams) =>
    requests(SERVICE_NAME.SURVEYS_API)
      .log({
        module: Module.FORMS_SURVEYS,
        entityType: EntityType.LOCATION,
        entityId: params.locationId,
      })
      .get("themes", { params }),

  getPrebuiltSurveysList: (params: GetThemesParams) =>
    requests(SERVICE_NAME.SURVEYS_API)
      .log({
        module: Module.FORMS_SURVEYS,
        entityType: EntityType.LOCATION,
        entityId: params.locationId,
      })
      .get("themes", {
        params: { ...params, isCategoryThemes: true },
      }),

  deleteThemeInSurveys: (themeId: string) =>
    requests(SERVICE_NAME.SURVEYS_API).delete(`themes/${themeId}`),
};

export default FormsAndSurveyServices;
